import { IDropDownTabOptions } from "../../Components/OptionsSelectDropdown/OptionsSelectDropdown";

export const VAMethodologyPageList : IDropDownTabOptions[] = [
	{ value: 'General', id: 1 },
	{ value: 'Ownership', id: 2 },
	{ value: 'Management Control', id: 3 },
	{ value: 'Skills Development', id: 4 },
	{ value: 'Preferential Procurement', id: 5 },
	{ value: 'Supplier Development', id: 6 },
	{ value: 'Enterprise Development', id: 7 },
	{ value: 'SED', id: 8 },
	{ value: 'RSM', id: 9 },
	{ value: 'Y.E.S Initiative', id: 10 },
	{ value: 'Empowering Supplier', id: 11 },
]